<div class="d-flex flex-column">
  <div class="progress">
    <div
      class="progress-bar progress-bar-striped progress-bar-animated bg-danger"
      role="progressbar"
      aria-valuenow="100"
      aria-valuemin="0"
      aria-valuemax="100"
      style="width: 100%"
    ></div>
  </div>
  <i *ngIf="!noText" class="loading-data">{{
    "common.loadingData" | translate
  }}</i>
</div>
